import { Chip } from "@mui/material";
import { convertStatusEnumToString } from "../utils/convertStatusEnumToString";
import { StatusEnum } from "../enums/status";

interface Props {
    status: boolean
}

const StatusChip = ({ status }: Props) => {
    return <Chip
        style={{
            backgroundColor: status ? '#36B37E29' : '#FF563029',
            color: status ? '#1B806A' : '#B71D18',
            borderRadius: '5px'
        }}
        label={status ? convertStatusEnumToString(StatusEnum.ACTIVE) : convertStatusEnumToString(StatusEnum.INACTIVE)}
    />
}
export default StatusChip;